import { useSelector } from 'react-redux';

import { InsightsList } from '../../../data/pricingPlansData';

import Slider from '../../Shared/ReactSlick';
import InsightsPlansBox from './InsightsPlansBox';

import Styles from './styles.module.scss';

const InsightsPricing = ({ isUserWithPlan, handlePlanRedirect }) => {
  const width = useSelector(({ common }) => (
    common.width
  ));

  const handleAddOnClick = (type) => {
    if (!isUserWithPlan) return;

    window.open('/users/chargebee', '_blank');
  };

  const sliderSettings = {
    dots: true,
    arrows: false,
    adaptiveHeight: false,
    appendDots: (dots) => (
      <>
        <ul className="slick-dots insights-pricing-slider-dots">{dots}</ul>
      </>
    ),
    infinite: false,
    centerPadding: '60px',
  };

  return (
    <div className={Styles['insights-pricing']}>
      <div className={Styles['insights-pricing-header']}>
        UK COMPANIES INSIGHTS
      </div>
      <div className={Styles['insights-pricing-details']}>
        <div className={Styles['insights-pricing-details-lists']}>
          {InsightsList.slice(0, 3).map((text, i) => (
            <div
              // eslint-disable-next-line react/no-array-index-key
              key={`list_1_${i}`}
              className={Styles['insights-pricing-details-list']}
            >
              <div className={Styles['insights-pricing-details-list-dot']} />
              <div className={Styles['insights-pricing-details-list-text']}>
                {text}
              </div>
            </div>
          ))}
        </div>
        <div className={Styles['insights-pricing-details-lists']}>
          {InsightsList.slice(3, 6).map((text, i) => (
            <div
              // eslint-disable-next-line react/no-array-index-key
              key={`list_1_${i}`}
              className={Styles['insights-pricing-details-list']}
            >
              <div className={Styles['insights-pricing-details-list-dot']} />
              <div className={Styles['insights-pricing-details-list-text']}>
                {text}
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className={Styles['insights-pricing-unlocks']}>
        <a href="https://www.cityfalcon.ai/help/articles/17242919532317" target="_blank" rel="noopener noreferrer">
          See unlocked insights
        </a>
        {' '}
        before signing up
      </div>
      <div className={Styles['insights-pricing-plans']} id="sub_uk_add_pricing">
        {width > 767 ? (
          <>
            <InsightsPlansBox
              planType="personal"
              isUserWithPlan={isUserWithPlan}
              handleAddOnClick={handleAddOnClick}
            />
            <InsightsPlansBox
              planType="enterprises"
              isUserWithPlan={isUserWithPlan}
              handleAddOnClick={handleAddOnClick}
            />
          </>
        ) : (
          <Slider {...sliderSettings}>
            <InsightsPlansBox
              planType="personal"
              isUserWithPlan={isUserWithPlan}
              handleAddOnClick={handleAddOnClick}
            />
            <InsightsPlansBox
              planType="enterprises"
              isUserWithPlan={isUserWithPlan}
              handleAddOnClick={handleAddOnClick}
            />
          </Slider>
        )}
      </div>
      <div className={Styles['insights-pricing-footer']}>
        {isUserWithPlan ? (
          <a
            className={Styles['insights-pricing-footer-btn']}
            href="/users/chargebee"
            target="_blank"
          >
            Manage Subscription
          </a>
        ) : (
          <>
            <div className={Styles['insights-pricing-footer-text']}>
              First choose a
              {' '}
              <span>
                Premium plan
              </span>
              {' '}
              then your add ons
            </div>
            <button
              type="button"
              className={Styles['insights-pricing-footer-btn']}
              onClick={handlePlanRedirect}
            >
              Subscribe to Premium
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default InsightsPricing;
